import { getPagePath } from '@spotahome/soyuz/client';

const COUNTRY_URLS = {
  france: {
    es: 'https://www.spotahome.com/es/w/country/alquileres-en-francia',
    en: 'https://www.spotahome.com/w/country/rentals-in-france',
    fr: 'https://www.spotahome.com/fr/w/country/locations-en-france',
    it: 'https://www.spotahome.com/it/w/country/affitti-in-francia',
    de: 'https://www.spotahome.com/de/w/country/mieten-in-frankreich',
    pt: 'https://www.spotahome.com/pt/w/country/arrendamentos-franca'
  },
  spain: {
    es: 'https://www.spotahome.com/es/w/country/alquileres-en-espana',
    en: 'https://www.spotahome.com/w/country/rentals-in-spain',
    fr: 'https://www.spotahome.com/fr/w/country/locations-en-espagne',
    it: 'https://www.spotahome.com/it/w/country/affitti-in-spagna',
    de: 'https://www.spotahome.com/de/w/country/mieten-in-spanien',
    pt: 'https://www.spotahome.com/pt/w/country/arrendamentos-espanha'
  },
  italy: {
    es: 'https://www.spotahome.com/es/w/country/alquileres-en-italia',
    en: 'https://www.spotahome.com/w/country/rentals-in-italy',
    fr: 'https://www.spotahome.com/fr/w/country/locations-en-italie',
    it: 'https://www.spotahome.com/it/w/country/affitti-in-italia',
    de: 'https://www.spotahome.com/de/w/country/mieten-in-italien',
    pt: 'https://www.spotahome.com/pt/w/country/arrendamentos-italia'
  },
  germany: {
    es: 'https://www.spotahome.com/es/w/country/alquileres-en-alemania',
    en: 'https://www.spotahome.com/w/country/rentals-in-germany',
    fr: 'https://www.spotahome.com/fr/w/country/locations-en-allemagne',
    it: 'https://www.spotahome.com/it/w/country/affitti-in-germania',
    de: 'https://www.spotahome.com/de/w/country/mieten-in-deutschland',
    pt: 'https://www.spotahome.com/pt/w/country/arrendamentos-alemanha'
  },
  portugal: {
    es: 'https://www.spotahome.com/es/w/country/alquileres-en-portugal',
    en: 'https://www.spotahome.com/w/country/rentals-in-portugal',
    fr: 'https://www.spotahome.com/fr/w/country/locations-en-portugal',
    it: 'https://www.spotahome.com/it/w/country/affitti-in-portogallo',
    de: 'https://www.spotahome.com/de/w/country/mieten-in-portugal',
    pt: 'https://www.spotahome.com/pt/w/country/arrendamentos-portugal'
  },
  uk: {
    es: 'https://www.spotahome.com/es/w/country/alquileres-en-reino-unido',
    en: 'https://www.spotahome.com/w/country/rentals-in-united-kingdom',
    fr: 'https://www.spotahome.com/fr/w/country/locations-en-royaume-uni',
    it: 'https://www.spotahome.com/it/w/country/affitti-in-regno-unito',
    de: 'https://www.spotahome.com/de/w/country/mieten-in-grossbritannien',
    pt: 'https://www.spotahome.com/pt/w/country/arrendamentos-reino-unido'
  }
};

const SPAIN_TRANSLATIONS = {
  es: 'espana',
  en: 'spain',
  fr: 'espagne',
  it: 'spagna',
  de: 'spanien',
  pt: 'espanha'
};

const FRANCE_TRANSLATIONS = {
  es: 'francia',
  en: 'france',
  fr: 'france',
  it: 'francia',
  de: 'frankreich',
  pt: 'franca'
};

const ITALY_TRANSLATIONS = {
  es: 'italia',
  en: 'italy',
  fr: 'italie',
  it: 'italia',
  de: 'italien',
  pt: 'italia'
};

const GERMANY_TRANSLATIONS = {
  es: 'alemania',
  en: 'germany',
  fr: 'allemagne',
  it: 'germania',
  de: 'deutschland',
  pt: 'alemanha'
};

const PORTUGAL_TRANSLATIONS = {
  es: 'portugal',
  en: 'portugal',
  fr: 'portugal',
  it: 'portogallo',
  de: 'portugal',
  pt: 'portugal'
};

const UK_TRANSLATIONS = {
  es: 'reino-unido',
  en: 'united-kingdom',
  fr: 'royaume-uni',
  it: 'regno-unito',
  de: 'grossbritannien',
  pt: 'reino-unido'
};
const COUNTRY_TRANSLATIONS = {
  spain: SPAIN_TRANSLATIONS,
  france: FRANCE_TRANSLATIONS,
  italy: ITALY_TRANSLATIONS,
  germany: GERMANY_TRANSLATIONS,
  portugal: PORTUGAL_TRANSLATIONS,
  uk: UK_TRANSLATIONS
};

const COUNTRY_TRANSLATIONS_BY_ISO_CODE = {
  ES: SPAIN_TRANSLATIONS,
  FR: FRANCE_TRANSLATIONS,
  IT: ITALY_TRANSLATIONS,
  DE: GERMANY_TRANSLATIONS,
  PT: PORTUGAL_TRANSLATIONS,
  GB: UK_TRANSLATIONS
};

export const getCountryUrl = (countryId, locale) => {
  return COUNTRY_URLS[countryId]?.[locale] || null;
};

export const getNewCountryUrl = (countryId, locale) => {
  if (!COUNTRY_TRANSLATIONS?.[countryId]?.[locale]) {
    return null;
  }

  return getPagePath('countries', {
    params: {
      country: COUNTRY_TRANSLATIONS[countryId][locale]
    }
  });
};

export const getNewCountryTranslationByIsoCode = (isoCode, locale) => {
  if (!COUNTRY_TRANSLATIONS_BY_ISO_CODE?.[isoCode]?.[locale]) {
    return null;
  }

  return getPagePath('countries', {
    params: {
      country: COUNTRY_TRANSLATIONS_BY_ISO_CODE[isoCode][locale]
    }
  });
};

export default getCountryUrl;
